import React from "react"
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api"
import Pin from "../../../static/assets/icons/location-marker.svg"

const containerStyle = {
  width: "-webkit-fill-available",
  height: "400px",
}

const center = {
  lat: 51.47039281689204,
  lng: -0.2578164956035825,
}

const mapOptions = {
  panControl: false,
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  overviewMapControl: false,
  rotateControl: false,
}

const key = process.env.GATSBY_GOOGLE_MAPS_STATIC_API_KEY

function Map() {
  return (
    <LoadScript googleMapsApiKey={key}>
      <GoogleMap
        options={mapOptions}
        mapContainerStyle={containerStyle}
        center={center}
        zoom={16}
      >
        <Marker
          position={center}
          // labelAnchor={new google.maps.Point(0, 0)}
          labelStyle={{
            backgroundColor: "yellow",
            fontSize: "32px",
            padding: "16px",
          }}
        ></Marker>
        <InfoWindow position={center} options={{ maxWidth: 150 }}>
          <div>
            <Pin />
            <h3>Tuva Partners</h3>
          </div>
        </InfoWindow>
      </GoogleMap>
    </LoadScript>
  )
}

export default React.memo(Map)
